import { renderCardPreview_unstable } from '@fluentui/react-card';

/**
 * Renders the final JSX of the CardPreview component, given the state.
 */
export const renderCardPreview = renderCardPreview_unstable;
